import React from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";

// Avisos do sistema (toast.success / toast.error / ...), no visual do tema.
// Ficam embaixo à esquerda: embaixo à direita já é o lugar dos avisos de
// novas mensagens (NotificationsPopOver), e assim os dois não se sobrepõem.

const transicao = cssTransition({
  enter: "ia-toast-entrar",
  exit: "ia-toast-sair",
  duration: [550, 350],
});

// cor, cor clara (fundo do ícone) e símbolo de cada tipo de aviso
const TIPOS = {
  success: { cor: "#22c55e", escura: "#16a34a", simbolo: "✓" },
  error: { cor: "#ef4444", escura: "#dc2626", simbolo: "!" },
  warning: { cor: "#f59e0b", escura: "#d97706", simbolo: "!" },
  info: { cor: "#14b8a6", escura: "#0d9488", simbolo: "i" },
  default: { cor: "#22c55e", escura: "#16a34a", simbolo: "✦" },
};

const useStyles = makeStyles((theme) => {
  const escuro = theme.palette.type === "dark";

  const porTipo = {};
  Object.entries(TIPOS).forEach(([tipo, t]) => {
    porTipo[`.Toastify__toast--${tipo}`] = {
      "--toast-cor": t.cor,
      "--toast-cor-onda": `${t.cor}66`,
      // o CSS padrão da biblioteca pinta o texto de branco em alguns tipos
      color: theme.palette.text.primary,
      background: escuro
        ? `radial-gradient(260px 90px at 0% 50%, ${t.cor}26, transparent 70%), #1b2320`
        : `radial-gradient(260px 90px at 0% 50%, ${t.cor}1f, transparent 70%), #ffffff`,
      "&::before": {
        content: `"${t.simbolo}"`,
        background: `linear-gradient(135deg, ${t.escura}, ${t.cor})`,
      },
    };
    porTipo[`.Toastify__progress-bar--${tipo}`] = {
      background: `linear-gradient(90deg, ${t.escura}, ${t.cor}, ${t.escura})`,
    };
  });

  return {
    "@global": {
      ".Toastify__toast-container": {
        width: 380,
        maxWidth: "calc(100vw - 32px)",
        padding: 0,
      },
      ".Toastify__toast-container--bottom-left": {
        bottom: 24,
        left: 24,
      },
      ".Toastify__toast": {
        position: "relative",
        overflow: "hidden",
        minHeight: 68,
        marginBottom: 12,
        padding: "14px 14px 14px 64px",
        borderRadius: 16,
        fontFamily: "'Poppins', 'Inter', sans-serif",
        fontSize: "0.88rem",
        fontWeight: 600,
        lineHeight: 1.4,
        color: theme.palette.text.primary,
        border: escuro ? "1px solid rgba(255,255,255,0.08)" : "1px solid #e3ece6",
        boxShadow: escuro
          ? "0 18px 40px rgba(0,0,0,0.55)"
          : "0 18px 40px rgba(16,40,28,0.16)",
        cursor: "pointer",
        transition: "transform .2s ease, box-shadow .2s ease",
        // faixa colorida à esquerda
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: 4,
          background: "var(--toast-cor)",
        },
        // ícone redondo com o símbolo do tipo: entra girando e solta uma onda
        "&::before": {
          position: "absolute",
          left: 16,
          top: "50%",
          width: 34,
          height: 34,
          marginTop: -17,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ffffff",
          fontSize: "1.05rem",
          fontWeight: 800,
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          animation: "iaIconePop .6s .15s cubic-bezier(0.34,1.56,0.64,1) both, iaOnda 1.4s .7s ease-out 2",
        },
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: escuro
            ? "0 22px 46px rgba(0,0,0,0.6)"
            : "0 22px 46px rgba(16,40,28,0.2)",
        },
      },
      ".Toastify__toast-body": {
        margin: 0,
        padding: 0,
      },
      ".Toastify__close-button": {
        color: theme.palette.text.secondary,
        opacity: 0.6,
        alignSelf: "flex-start",
        transition: "opacity .2s ease, transform .2s ease",
        "&:hover": { opacity: 1, transform: "rotate(90deg)" },
      },
      ".Toastify__progress-bar": {
        height: 3,
      },
      ...porTipo,
    },
  };
});

const Notificacoes = () => {
  useStyles();
  return (
    <ToastContainer
      position="bottom-left"
      autoClose={3500}
      transition={transicao}
      newestOnTop
      hideProgressBar={false}
      closeOnClick
      pauseOnHover
    />
  );
};

export default Notificacoes;
